export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20bold%20white%20high-top%20sneakers%20with%20bright%20orange%20and%20green%20accents%20standing%20on%20a%20warm%20terracotta%20studio%20background%2C%20dynamic%20diagonal%20angle%2C%20crisp%20editorial%20sneaker%20photography%20with%20hard%20directional%20lighting%20and%20a%20clean%20uncluttered%20composition&width=800&height=600&seq=cat-shoes-01&orientation=landscape&nocache=true",
  },
  {
    key: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20chunky%20knit%20hoodie%20in%20mustard%20yellow%20draped%20over%20a%20wooden%20chair%20against%20a%20soft%20sage%20green%20wall%2C%20warm%20afternoon%20light%2C%20cozy%20editorial%20fashion%20photography%20with%20rich%20fabric%20texture%20and%20a%20relaxed%20composition&width=800&height=600&seq=cat-hoodies-02&orientation=landscape&nocache=true",
  },
  {
    key: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Colorful%20folded%20cotton%20t-shirts%20in%20pastel%20pink%20mint%20and%20peach%20stacked%20in%20a%20rainbow%20row%20on%20a%20clean%20light%20pink%20surface%2C%20playful%20flat%20lay%2C%20bright%20cheerful%20editorial%20product%20photography%20with%20soft%20even%20lighting&width=800&height=600&seq=cat-tshirts-03&orientation=landscape&nocache=true",
  },
  {
    key: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-temp-cold-line",
    image: "https://readdy.ai/api/search-image?query=A%20classic%20black%20leather%20jacket%20and%20a%20blue%20denim%20jacket%20hanging%20on%20a%20metal%20rack%20against%20a%20warm%20cream%20brick%20wall%2C%20urban%20editorial%20fashion%20photography%2C%20soft%20window%20light%2C%20rich%20material%20texture%20and%20a%20stylish%20composition&width=800&height=600&seq=cat-jackets-04&orientation=landscape&nocache=true",
  },
  {
    key: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-archive-line",
    image: "https://readdy.ai/api/search-image?query=Folded%20blue%20denim%20jeans%20and%20olive%20green%20cargo%20pants%20arranged%20in%20neat%20stacks%20on%20a%20warm%20sand%20colored%20linen%20surface%2C%20casual%20editorial%20product%20photography%2C%20soft%20natural%20side%20light%20with%20gentle%20shadows&width=800&height=600&seq=cat-pants-05&orientation=landscape&nocache=true",
  },
  {
    key: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-customer-service-line",
    image: "https://readdy.ai/api/search-image?query=A%20collection%20of%20baseball%20caps%20and%20cozy%20beanies%20in%20mustard%20navy%20and%20cream%20arranged%20on%20a%20warm%20honey%20yellow%20background%2C%20flat%20lay%20editorial%20photography%2C%20soft%20diffused%20lighting%20and%20a%20playful%20tidy%20composition&width=800&height=600&seq=cat-headwear-06&orientation=landscape&nocache=true",
  },
  {
    key: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-layout-grid-line",
    image: "https://readdy.ai/api/search-image?query=A%20matching%20coral%20tracksuit%20set%20laid%20flat%20with%20white%20sneakers%20on%20a%20soft%20peachy%20background%2C%20sporty%20editorial%20product%20photography%2C%20bright%20airy%20lighting%20with%20a%20fresh%20energetic%20composition&width=800&height=600&seq=cat-sets-07&orientation=landscape&nocache=true",
  },
  {
    key: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-circle-line",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20in%20white%20and%20muted%20pastel%20tones%20folded%20into%20neat%20rolls%20on%20a%20soft%20mint%20green%20surface%2C%20clean%20minimal%20editorial%20product%20photography%20with%20gentle%20natural%20lighting&width=800&height=600&seq=cat-underwear-08&orientation=landscape&nocache=true",
  },
  {
    key: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20vibrant%20athletic%20football%20jersey%20with%20bold%20red%20and%20white%20stripes%20laid%20flat%20on%20a%20fresh%20green%20grass%20like%20studio%20background%2C%20sporty%20editorial%20product%20photography%20with%20crisp%20lighting%20and%20an%20energetic%20composition&width=800&height=600&seq=cat-jersey-09&orientation=landscape&nocache=true",
  },
  {
    key: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-brush-line",
    image: "https://readdy.ai/api/search-image?query=A%20stylish%20flat%20lay%20of%20sunglasses%20a%20leather%20watch%20and%20a%20silver%20bracelet%20arranged%20on%20a%20warm%20walnut%20wood%20surface%2C%20luxury%20editorial%20product%20photography%20with%20soft%20directional%20light%20and%20rich%20shadows&width=800&height=600&seq=cat-accessories-10&orientation=landscape&nocache=true",
  },
  {
    key: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-shopping-bag-line",
    image: "https://readdy.ai/api/search-image?query=An%20elegant%20tan%20leather%20handbag%20and%20a%20natural%20canvas%20tote%20bag%20standing%20upright%20on%20a%20soft%20cream%20stone%20surface%2C%20premium%20editorial%20product%20photography%2C%20soft%20natural%20window%20light%20with%20gentle%20shadows&width=800&height=600&seq=cat-bags-11&orientation=landscape&nocache=true",
  },
  {
    key: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=Rolled%20leather%20belts%20in%20cognac%20brown%20and%20black%20arranged%20in%20a%20spiral%20pattern%20on%20a%20warm%20tan%20leather%20surface%2C%20luxury%20editorial%20product%20photography%20with%20soft%20dramatic%20lighting&width=800&height=600&seq=cat-belts-12&orientation=landscape&nocache=true",
  },
  {
    key: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20with%20a%20gold%20cap%20resting%20on%20soft%20caramel%20silk%20fabric%20with%20scattered%20white%20flower%20petals%2C%20luxury%20editorial%20product%20photography%2C%20warm%20glowing%20backlight&width=800&height=600&seq=cat-perfumes-13&orientation=landscape&nocache=true",
  },
  {
    key: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-2-line",
    image: "https://readdy.ai/api/search-image?query=A%20tidy%20flat%20lay%20of%20a%20knit%20scarf%20wool%20socks%20and%20a%20leather%20wallet%20in%20earthy%20tones%20on%20a%20soft%20oatmeal%20fabric%20background%2C%20cozy%20editorial%20product%20photography%20with%20soft%20even%20lighting&width=800&height=600&seq=cat-other-14&orientation=landscape&nocache=true",
  },
];